<template>
    <div 
        @scroll="continuesscroll"
        class="holesDeliveries">
        <b-container class="positionrelative">
            <template v-if="activetab == 1">
                <div class="orderlistorfilter">
                    <div
                        @click="filterorderlist('pending')"
                        :class="['filteritem pending', {'active' : orderfilteredlist.includes('assign')}]"
                    >
                        Pending Request
                    </div>
                    <div
                        @click="filterorderlist('accepted')"
                        :class="['filteritem accepted', {'active' : orderfilteredlist.includes('accepted')}]"
                    >
                        Accepted
                    </div>
                    <div
                        @click="filterorderlist('delivered')"
                        :class="['filteritem delivered', {'active' : orderfilteredlist.includes('delivered')}]"
                    >
                        Delivered
                    </div>
                </div>
            </template>

            <b-tabs
                v-model="activetab"
                :justified="
                    !['lg', 'xl', 'xxl'].includes(windowsize.breakpoint)
                "
            >
                <b-tab active>
                    <template #title> Unassigned </template>
                    <unassigned
                        :assignedorders="assignedorders"
                        @update="updatelist"
                        ref="unassignlist"
                    />
                </b-tab>

                <b-tab>
                    <template #title> In Progress </template>

                    <order-list
                        @update="updatelist"
                        :orderfilteredlist.sync="orderfilteredlist"
                        :assignedorders.sync="assignedorders"
                        ref="orderlist"
                    />
                </b-tab>

                <b-tab>
                    <template #title> History </template>
                    <order-history ref="historylist" />
                </b-tab>
            </b-tabs>
        </b-container>
    </div>
</template>

<script>
// components
import unassignedlist from "@/components/admin/unassignedlist.vue";
import orderList from "@/components/admin/orderList.vue";
import orderHistory from "@/components/admin/orderHistoryList.vue";

export default {
    components: {
        unassigned: unassignedlist,
        "order-list": orderList,
        "order-history": orderHistory,
    },
    data() {
        return {
            assignedorders   : [],
            activetab        : 0,
            orderfilteredlist: ['assign', 'accepted', 'delivered', 'amend'],
        };
    },
    computed: {
        windowsize() {
            return this.$store.state.windowsize;
        },
    },
    methods: {
        /**
         * Continues scroll
         */
        continuesscroll() {
            console.log('adsfasdf')
            let tabcomponent = null
            switch (this.activetab) {
                case 0:
                    tabcomponent = this.$refs.unassignlist

                    if(tabcomponent) {
                        tabcomponent.continuesscroll()
                    }
                    break;
            
                case 1:
                    tabcomponent = this.$refs.orderlist
                    if(tabcomponent) {
                        tabcomponent.continuesscroll()
                    }
                    
                    break;

                case 2:
                    tabcomponent = this.$refs.historylist
                    if(tabcomponent) {
                        tabcomponent.continuesscroll()
                    }
                    break;
            
                default:
                    break;
            }
        },
        /**
         * Filter order list
         */
        filterorderlist(type) {
            const orderlist = this.$refs.orderlist

            if(orderlist) {
                orderlist.filterlist(type)
            }
        },
        /**
         * New update from order list should update by type
         * Webhook emit updates
         */
        updatelist(type) {
            console.log("update list ", type);

            switch (type) {
                case "all":
                    this.$refs.orderlist.getallassignedorders();
                    this.$refs.unassignlist.getunassignedorders();

                    break;

                case "orderlist":
                    this.$refs.orderlist.getallassignedorders();

                    break;

                case "unassigned":
                    this.$refs.unassignlist.getunassignedorders();

                    break;

                default:
                    break;
            }

            this.$refs.historylist.getemployerhistory();
        },
    },
    /**
     * Run function before component render
     */
    beforeMount() {
        // Get orders
        this.$store.dispatch("getorders");
    },
    mounted() {},
};
</script>

<style lang="scss">
@import "@/scss/partials/_mixins.scss";
@import "@/scss/partials/_colors.scss";

.holesDeliveries {
    max-height: 100vh;
    overflow  : hidden auto;

    @include screen-min(lg) {
        background-color: $lightgrey;
        min-height: 100vh;
        padding-top: 30px;
    }

    .positionrelative {
        position: relative;
    }

    .orderlistorfilter {
        position   : absolute;
        right      : 15px;
        display    : flex;
        align-items: center;
        height     : 40px;
        display: none;

        @include screen-min(lg) {
            display: flex;
        }

        .filteritem {
            margin-left: 20px;
            display    : flex;
            align-items: center;
            opacity: 0.5;

            &.active {
                opacity: 1;
            }

            &::before {
                content         : '';
                width           : 15px;
                height          : 15px;
                display         : block;
                border-radius   : 100%;
                margin-right    : 8px;
            }

            &.pending {
                &::before {
                    background-color: $primaryColor;
                }
            }

            &.accepted {
                &::before {
                    background-color: transparent;
                    border          : 1px solid $grey;
                }
            }

            &.delivered {
                &::before {
                    background-color: $green;
                }
            }
        }
    }

    .tabs {
        .nav-tabs {
            @include screen-min(lg) {
                border-bottom: none;
                margin-bottom: 30px;
            }
        }

        .nav-item {
            .nav-link {
                border-color : transparent;
                border       : none;
                border-bottom: 2.5px solid transparent;
                font-weight  : 700;
                outline      : none !important;

                @include screen-min(lg) {
                    border-bottom: 2.5px solid $lightgrey3;
                    padding-right: 30px;

                    &:first-child {
                        padding-left: 0;
                    }
                }

                &:hover {
                    color: $primaryColor;
                    outline      : none !important;
                }

                &:focus {
                    outline      : none !important;
                }

                &.active {
                    border-bottom: 2.5px solid $primaryColor;
                    font-weight: 800;
                    color: $black;
                    outline      : none !important;

                    @include screen-min(lg) {
                        background-color: transparent;
                    }
                }
            }
        }
    }
}
</style>
